import React, {Component} from 'react'
import { Row, Col } from 'react-flexbox-grid';
import { Link } from 'react-router-dom'
import './footer-styles.css'

export default class Footer extends Component{
  render(){
    return(
      <footer>
        <Row center='xs' middle='xs'>
          <Col xs={12} md={1}>
            <Link to="/">Home</Link>
          </Col>
          <Col xs={12} md={1}>
            <Link to="/support">Support</Link>
          </Col>
          <Col xs={12} md={1}>
            <Link to="/jobs">Jobs</Link>
          </Col>
        </Row>
        <Row center='xs' middle='xs'>
          <Col>
            <p className='footer-text'>Copyright © {(new Date()).getFullYear()} UniversityGO LLC.</p>
          </Col>
        </Row>
      </footer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Views/Footer/Footer.js